import { Log } from '../AuxillaryService/Log';

/**
 * Class to facilitate communication between cross-domain
 * parent and child iframe
 */
export default class IframeMessenger {
    /**
     * Any Window object, child or parent
     */
    readonly targetWindow: Window;

    /**
     * Target domain with protocol. E.g. https://webapp.reachcm.com
     */
    readonly targetOrigin: string;

    /**
     * Callback function for messages received from iframe
     * console.log as the default listener
     */
    private callback: (event: unknown) => void = console.log;

    /**
     * Creates an instance of IframeMessenger.
     * @param targetWindow - Any Window object, child or parent
     * @param targetOrigin - Target domain with protocol. E.g. https://webapp.reachcm.com
     */
    constructor(targetWindow: Window, targetOrigin: string) {
        this.targetWindow = targetWindow;
        this.targetOrigin = targetOrigin;

        window.addEventListener('message', this.messageEventListener.bind(this), false);
    }

    /**
     * Verifies the message source and calls callback on message data
     */
    private messageEventListener(event: MessageEvent): void {
        Log.Info('Message received from parent iframe: ', null, __fileline, event);
        if (event.origin !== this.targetOrigin) {
            Log.Warning('Message received from unverified source: ', null, __fileline, event);
            return;
        }

        const message: unknown = event.data;
        this.callback(message);
    }

    /**
     * Adds custom event listener for iframe messages
     */
    public setMessageEventListener(callback: (event: unknown) => void): void {
        this.callback = callback;
    }

    /**
     * Post a message to target iframe window
     */
    public post(data: Record<string | number, unknown>): void {
        this.targetWindow.postMessage(data, this.targetOrigin);
    }
}
